import React from 'react';
import Navbar from '../Navbar';

export default function Hero(props) {
  return (
    <div className="relative bg-cover lg:after:bg-opacity-50 lg:after:bg-gradient-to-b lg:after:from-black lg:after:content-[''] lg:after:w-full lg:after:h-full lg:after:absolute lg:after:bottom-0">
      <div className="container mx-auto px-[4%]">
        <Navbar />
      </div>
      <div className="flex flex-col justify-center items-center">
        <img src={props.imgSrc} alt="image" className="lg:-mt-[150px] lg:h-auto mt-0 h-[400px]" />
        <h1 className="lg:text-4xl sm:text-2xl text-xl text-white -mt-[5%] font-medium z-10 w-2/5 text-center absolute">
          {props.text}
        </h1>
      </div>
    </div>
  );
}
